import URL from '../url'
import Request from '../request'

/**
 *
 * @param {*} query
 */
export const getEmailDomainRulesService = query =>
  new Request(URL.API, URL.LIST_EMAIL_DOMAIN_RULE).get(query)

/**
 *
 * @param {*} data
 */
export const addEmailDomainRuleService = data =>
  new Request(URL.API, URL.ADD_EMAIL_DOMAIN_RULE).post(data)

/**
 *
 * @param {*} data
 */
export const updateEmailDomainRuleService = data =>
  new Request(URL.API, URL.UPDATE_EMAIL_DOMAIN_RULE).put(data)

/**
 *
 * @param {*} id
 */
export const deleteEmailDomainRuleService = id =>
  new Request(URL.API, URL.DELETE_EMAIL_DOMAIN_RULE.replace('{id}', id)).delete()
